<div class="container">
    <div class="row crud-header">
        <div class="col flex-shrink-0 text-nowrap d-flex align-items-center gap-3">
            <div [routerLink]="['/', Routenames.TtmTickets]" class="controls-left-button" matTooltip="Terug naar projectenkaart" matTooltipPosition="after">
                <i class="fa fa-arrow-left-from-arc"></i>
            </div>
            <h1 class="mt-2">TVM-tickets</h1>
        </div>
    </div>

    @if(ttmTicket(); as ticket) {
    <div class="col bg-white p-4 rounded shadow-sm mb-4">
        <div class="d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-center mb-3 gap-2 gap-lg-0">
            <h3>Ticket #{{ ticket.id }} - {{ ticket.type | TtmTicketType }}</h3>
            <div class="d-flex align-items-center gap-3 justify-content-between full-width-mobile">
                <mat-chip>{{ ticket.department | TtmTicketDepartment }}</mat-chip>
                <i class="fa pointer"
                    (click)="toggleMuteNotifications()"
                    [ngClass]="ticket.is_muted?.email_enabled ? 'fa-bell' : 'fa-bell-slash'"
                    [matTooltip]="ticket.is_muted?.email_enabled ?  'Notificaties staan aan' : 'Notificaties zijn gedempt'"
                    matTooltipPosition="below"
                    matTooltipTouchGestures="off"></i>
            </div>
        </div>

        @if (!isEditingTicket) {
            <div class="d-flex flex-row justify-content-between align-items-center mb-3 gap-2 gap-lg-0">
                <h4 class="mb-0">Opmerking: {{ ticket.comment || 'Geen opmerking' }}</h4>
                @if ((ticket.user_id === currentUser?.id || ticket.assignee_id === currentUser?.id) || (((ticket.department === 'technical') && (Roles.Codalt | hasRole)) || ((ticket.department === 'design') && (Roles.Drawer | hasRole)))) {
                    <button mat-icon-button color="primary" (click)="startEditingTicket()" matTooltip="Opmerking bewerken">
                        <i class="fa fa-edit"></i>
                    </button>
                }
            </div>
        } @else {
            <form [formGroup]="ticketForm" class="mb-3">
                <div class="mb-3">
                    <mat-form-field class="w-100">
                        <mat-label>Ticket opmerking</mat-label>
                        <textarea
                            matInput
                            formControlName="comment"
                            placeholder="Voeg een opmerking toe aan dit ticket..."
                            rows="3">
                        </textarea>
                        <mat-error *ngIf="ticketForm.get('comment')?.hasError('maxlength')">
                            Opmerking mag maximaal 1000 karakters bevatten
                        </mat-error>
                    </mat-form-field>
                </div>
            </form>
        }

        <div class="d-flex flex-column flex-lg-row justify-content-between mb-2 gap-2 gap-lg-0">
            <h5>Aangemaakt door: {{ ticket.user?.name }}</h5>
            <h5>Aangemaakt op: {{ ticket.created_at | date : "EEE d MMM yyyy HH:mm" }}</h5>
             @if (!isEditingTicket) {
                <div class="d-flex justify-content-between">
                    <h5>Status: {{ ttmTicket()?.status | TtmTicketStatus}}</h5>
                </div>
            } @else {
                <form [formGroup]="ticketForm">
                    <ng-select class="user-select" formControlName="status" placeholder="Status" bindLabel="name" bindValue="key" [items]="ticketStatuses" [clearable]="false"></ng-select>
                </form>
            }
            @if (!isEditingTicket) {
                <div class="d-flex align-items-center gap-2">
                    <h5>Toegewezen aan: {{ ticket.assignee?.name || "Niet toegewezen" }}</h5>
                </div>
            } @else {
                <form [formGroup]="ticketForm">
                    <ng-select class="user-select" formControlName="assignee_id" placeholder="Toewijzen aan" bindLabel="name" bindValue="id" [items]="users" [clearable]="true"></ng-select>
                </form>
            }
        </div>

        @if(isEditingTicket) {
            <div class="d-flex justify-content-end gap-2">
                <button mat-stroked-button (click)="cancelEditingTicket()">
                    Annuleren
                </button>
                <button mat-raised-button color="primary"  [disabled]="ticketForm.invalid" (click)="saveTicket()">
                    Opslaan
                </button>
            </div>
        }
    </div>

    <div class="col bg-white p-4 rounded shadow-sm mb-4">
        <div class="d-flex flex-row justify-content-between align-items-start align-items-lg-center mb-3 gap-2 gap-lg-0">
            <h3>TVM #{{ ticket.ttm?.id }}</h3>
            <a color="primary"
                mat-flat-button
                routerLink="/{{Routenames.Projects}}/{{ticket.ttm?.project_id}}"
                [queryParams]="{ttm: ticket.ttm_id, drawing: ticket.ttm?.entities[0]?.drawings[0]?.id}">
                <i class="fa fa-external-link"></i>
            </a>
        </div>
        <div class="d-flex flex-row justify-content-between align-items-start align-items-lg-center mb-3 gap-2 gap-lg-0">
            <h4 class="mb-0">{{ (ttmTypes | byKey : ticket.ttm.type_key)?.name }}</h4>
            <mat-chip [style.background-color]="'#' + (ttmStatuses | byKey : ticket.ttm.status_key)?.color">
                {{ (ttmStatuses | byKey : ticket.ttm.status_key)?.name }}
            </mat-chip>
        </div>
        <div *ngFor="let entity of ticket.ttm.entities" class="mb-3">
            <div class="entity-header mb-2">
                <h4 class="entity-handle">{{ entity.handle }}</h4>
                <h5 class="entity-name">{{ entity.name }}</h5>
                <a class="entity-coordinates" href="https://maps.google.com/?q={{ entity.gnd.coordinates[0][1] }},{{ entity.gnd.coordinates[0][0] }}" target="_blank">
                    {{ entity.gnd.coordinates[0][1] | number : "0.0-3" }}, {{ entity.gnd.coordinates[0][0] | number : "0.0-3" }}
                </a>
            </div>
            <div class="d-flex justify-content-evenly">
                <div class="ttm-image" app-svg-as-img [svg]="entity?.plain_image?.svg"></div>
                <div class="ttm-image" app-svg-as-img [svg]="entity?.projected_image?.svg"></div>
                @if (entity?.gnd_image?.svg) {
                <div class="ttm-image" app-svg-as-img [svg]="entity?.gnd_image?.svg"></div>
                }
            </div>
        </div>
    </div>

    <div class="col bg-white p-4 rounded shadow-sm mb-4">
        <h3>Opmerkingen</h3>
        <div class="mb-3">
            @for (comment of ticket.comments; track $index) {
                <div class="d-flex flex-row align-items-center justify-content-between gap-2">
                    <h5>{{ comment.user?.name }}</h5>
                    <div class="d-flex align-items-center gap-2">
                        <h5>{{ comment.created_at | date : "EEE d MMM yyyy HH:mm" }}</h5>
                        @if (comment.user?.id === currentUser?.id) {
                            <button mat-icon-button color="warn" (click)="deleteComment(comment)" matTooltip="Opmerking verwijderen">
                                <mat-icon>delete</mat-icon>
                            </button>
                        }
                    </div>
                </div>
                <p>{{ comment.comment }}</p>
            }
        </div>
        <form [formGroup]="commentForm" (ngSubmit)="onSubmitComment()" class="mt-4">
            <div class="mb-3">
                <mat-form-field class="w-100">
                    <mat-label>Nieuwe opmerking</mat-label>
                    <textarea
                        matInput
                        formControlName="text"
                        placeholder="Voeg een opmerking toe..."
                        rows="3"
                        required>
                    </textarea>
                    <mat-error *ngIf="commentForm.get('text')?.hasError('required')">
                        Opmerking is verplicht
                    </mat-error>
                    <mat-error *ngIf="commentForm.get('text')?.hasError('minlength')">
                        Opmerking moet minimaal 1 karakter bevatten
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="d-flex justify-content-end">
                <button
                    type="submit"
                    mat-raised-button
                    color="primary"
                    [disabled]="commentForm.invalid">
                    Opmerking toevoegen
                </button>
            </div>
        </form>
    </div>
    }
</div>
